// Entry point for the build script in your package.json
import { initMainNavigation } from "./features/navigation";

document.addEventListener("DOMContentLoaded", () => {
  initMainNavigation();
});
